import {useEffect, useState} from "react";
import useStandardPolling from "./useStandardPolling";

import {PollingResult} from "../service/mfaPushService.types";
import {pollTicket} from "../service/mfaPushService";
import {useCountDown} from "./useCountDown";

export interface UseDeviceConfirmationResult {
    confirmedPollingTicket: PollingResult | null,
    retrySeconds: number,
    retryAllowed: boolean,
    pollingError: boolean,
    cancelPolling: () => void
}

export default function useDeviceConfirmation(ticketId: string | undefined, userId: string | undefined): UseDeviceConfirmationResult {
    const [pollingTicketId, setPollingTicketId] = useState<string | undefined>(ticketId);
    const [confirmedPollingTicket, setConfirmedPollingTicket] = useState<PollingResult | null>(null);
    const [pollingError, setPollingError] = useState<boolean>(false);
    const {remainingSeconds: retrySeconds, restart: resetRetrySeconds} = useCountDown(15);

    useEffect(() => {
        setPollingTicketId(ticketId);
    }, [ticketId])

    //----------------------------------------------------------------------------
    //      Poll the ticket
    //----------------------------------------------------------------------------
    const {stopPolling} = useStandardPolling(!!pollingTicketId, 3000, async () => {
        if (pollingTicketId && userId) {
            await pollTicket(pollingTicketId, userId, {
                onSuccess(pollResult: PollingResult): void {
                    if (pollResult.status === "CONFIRMED") {
                        stopPolling()
                        setConfirmedPollingTicket(pollResult)
                    }
                },
                onError(error: any): void {
                    stopPolling()
                    setPollingError(true);
                }
            })
        }
    });

    const cancelPolling = () => {
        setPollingError(false);
        setPollingTicketId(undefined);
        resetRetrySeconds();
    }

    return {
        confirmedPollingTicket: confirmedPollingTicket,
        retrySeconds: retrySeconds,
        retryAllowed: retrySeconds <= 0,
        pollingError: pollingError,
        cancelPolling: cancelPolling
    };
}